import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
@connect((store) => {
  return {
    conversations: store.conversations,
  };
})
class Actions extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { conversations, onAction, message: messageObj } = this.props;
    const message =
      typeof conversations.fields.message === 'string'
        ? JSON.parse(conversations.fields.message)
        : conversations.fields.message;
    const hasMessageCreate =
      (message.blocks || []).filter((b) => b.text && !b.text.match(/^\s+$/g)).length > 0;

    const onnew =
      this.props.actionType !== 'send'
        ? !_.isEqual(conversations.fieldsInit, conversations.fields) &&
          conversations.fields.subject.trim().length > 0 &&
          conversations.fields.to.length > 0
        : true;
    const activeFile = conversations.files.filter((f) => !f.cancelled);
    const hasUpload = conversations.files.length > 0 && activeFile.length > 0;
    const hasMessage =
      (hasMessageCreate && hasUpload && activeFile.length > 0) ||
      (hasMessageCreate && !hasUpload);
    const noMessageWithUpload =
      !hasMessageCreate && hasUpload && activeFile.length > 0;

    const hasChanges = onnew && (hasMessage || noMessageWithUpload);

    const handleSubmit = () => {
      if (onAction) {
        onAction();
      }
    };

    return (
      <div class="toolbar-buttons action-buttons">
        <ul>
          <li>
            <a class={`sendBtn ${hasChanges ? 'active' : ''}`} onClick={handleSubmit}>
              Send
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default Actions;
